// Tears down any service worker still registered for this origin.
//
// The app used to register a Workbox worker (CRA 1.x). react-scripts 5 no
// longer generates one, so registration has been vestigial for years -- while
// the 2021 worker stayed installed in browsers, serving a 2021 copy of the app
// from cache. See public/service-worker.js for the other half of the removal.

export default function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      registrations.forEach(registration => registration.unregister());
    })
    .catch(error => {
      console.error('Error unregistering service worker:', error);
    });
}
